exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".e-btn.cart-qtt.btn-gradient[data-v-19c4d6da]{width:150px;cursor:pointer}.e-btn.cart-qtt.btn-gradient a[data-v-19c4d6da]{margin-left:16px}", ""]);

// exports
